import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../../../src/environments/environment';
import { UserService } from '../../../user.service';
// ✅ AJOUTER switchMap dans les imports
@Injectable({
    providedIn: 'root'
})
export class AfrobotService {
    private STRAPI_URL = environment.API_URL;

    constructor(private http: HttpClient, private userService: UserService) { }

    // Méthode pour récupérer le token JWT de l'utilisateur connecté
    private getAuthHeaders(): HttpHeaders {
        const token = this.userService.getToken();
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        });
    }

    askAfrobotN8n(message: string, sessionId?: string): Observable<any> {
        const payload = {
            message: message, // ⚠️ Renommé de "chatInput" à "message"
            sessionId: sessionId || this.generateSessionId()
        };

        // ✅ Appeler Strapi au lieu de N8N directement
        return this.http.post(`${this.STRAPI_URL}/afrobot/chat`, payload, {
            headers: this.getAuthHeaders() // Utilise le JWT de l'utilisateur
        }).pipe(
            map((response: any) => {
                if (response.error) {
                    throw new Error(response.message || 'Erreur serveur');
                }

                return {
                    reply: response.reply,
                    sessionId: response.sessionId
                };
            }),
            catchError(error => {
                console.error('Erreur chat:', error);
                return throwError(() => ({
                    message: 'Désolé, une erreur est survenue.',
                    originalError: error
                }));
            })
        );
    }

    getUserQuestionCount(userId: number): Observable<number> {
        if (!userId) return of(0);

        return this.http.get<any>(`${this.STRAPI_URL}/afrobot/count`, {
            headers: this.getAuthHeaders()
        }).pipe(
            map(res => res.count || 0),
            catchError(error => {
                console.error('Erreur récupération compteur:', error);
                return of(0);
            })
        );
    }

    incrementUserQuestionCount(userId: number): Observable<number> {
        if (!userId) return of(0);

        return this.http.post<any>(`${this.STRAPI_URL}/afrobot/increment`, {}, {
            headers: this.getAuthHeaders()
        }).pipe(
            map(res => {
                console.log(`✅ Compteur incrémenté: ${res.count}`);
                return res.count;
            }),
            catchError(error => {
                console.error('❌ Erreur incrémentation compteur:', error);
                return of(0);
            })
        );
    }

    sendFeedback(messageId: string, feedback: 'like' | 'dislike' | null, sessionId: string): Observable<any> {
        const payload = {
            data: {
                messageId,
                feedback,
                sessionId,
                timestamp: new Date().toISOString()
            }
        };

        return this.http.post(`${this.STRAPI_URL}/afrobot-feedbacks`, payload, {
            headers: this.getAuthHeaders()
        }).pipe(
            catchError(error => {
                console.error('Erreur envoi feedback:', error);
                return of(null);
            })
        );
    }

    private generateSessionId(): string {
        return 'afrotech-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    }
}